// extracted by mini-css-extract-plugin
module.exports = {"creationHeader":"Header_creationHeader__3D16H","title":"Header_title__31NWO","creationActions":"Header_creationActions__1Yws5","actionSlot":"Header_actionSlot__3xmJ0"};